// Version : 0.0.2
// Author : Nandhakumar
// LastEdit : Nandhakumar
// Last Add : 'Converted Existed Values for the Keys from Upper Case to Smaller Case'
// Modified Date : 4-12-2025

import GoldLoanActionTypes from './gold-loan-collection.types';

/** ***************** GET GOLD LOAN INDEXS DETAILS START *********************** */
export const getGoldLoanIndexDetailsStart = (getData: any) => ({
	type: GoldLoanActionTypes.GET_GOLD_LOAN_INDEX_DETAILS_START,
	payload: getData,
});

export const getGoldLoanIndexDetailsSuccess = (successData: any) => ({
	type: GoldLoanActionTypes.GET_GOLD_LOAN_INDEX_DETAILS_SUCCESS,
	payload: successData,
});

export const getGoldLoanIndexDetailsFailure = (failureData: any) => ({
	type: GoldLoanActionTypes.GET_GOLD_LOAN_INDEX_DETAILS_FAILURE,
	payload: failureData,
});

export const getGoldLoanIndexDetailsResponseResetStart = () => ({
	type: GoldLoanActionTypes.GET_GOLD_LOAN_INDEX_DETAILS_RESPONSE_RESET,
});

export const getGoldLoanIndexDetailsResponseChanged = () => ({
	type: GoldLoanActionTypes.GET_GOLD_LOAN_INDEX_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET GOLD LOAN INDEXS DETAILS END *********************** */

/** ***************** GET GOLD LOAN INDEXS INFO START *********************** */
export const getGoldLoanIndexInfoStart = (getData: any) => ({
	type: GoldLoanActionTypes.GET_GOLD_LOAN_INDEX_INFO_START,
	payload: getData,
});

export const getGoldLoanIndexInfoSuccess = (successData: any) => ({
	type: GoldLoanActionTypes.GET_GOLD_LOAN_INDEX_INFO_SUCCESS,
	payload: successData,
});

export const getGoldLoanIndexInfoFailure = (failureData: any) => ({
	type: GoldLoanActionTypes.GET_GOLD_LOAN_INDEX_INFO_FAILURE,
	payload: failureData,
});

export const getGoldLoanIndexInfoResponseResetStart = () => ({
	type: GoldLoanActionTypes.GET_GOLD_LOAN_INDEX_INFO_RESPONSE_RESET,
});

export const getGoldLoanIndexInfoResponseChanged = () => ({
	type: GoldLoanActionTypes.GET_GOLD_LOAN_INDEX_INFO_RESPONSE_CHANGED,
});
/** ***************** GET GOLD LOAN INDEXS INFO END *********************** */

/** ***************** GET GOLD LOAN INDEXS INFO START *********************** */
export const deleteGoldLoanIndexStart = (getData: any) => ({
	type: GoldLoanActionTypes.DELETE_GOLD_LOAN_INDEX_START,
	payload: getData,
});

export const deleteGoldLoanIndexSuccess = (successData: any) => ({
	type: GoldLoanActionTypes.DELETE_GOLD_LOAN_INDEX_SUCCESS,
	payload: successData,
});

export const deleteGoldLoanIndexFailure = (failureData: any) => ({
	type: GoldLoanActionTypes.DELETE_GOLD_LOAN_INDEX_FAILURE,
	payload: failureData,
});

export const deleteGoldLoanIndexResponseResetStart = () => ({
	type: GoldLoanActionTypes.DELETE_GOLD_LOAN_INDEX_RESPONSE_RESET,
});

export const deleteGoldLoanIndexResponseChanged = () => ({
	type: GoldLoanActionTypes.DELETE_GOLD_LOAN_INDEX_RESPONSE_CHANGED,
});
/** ***************** GET GOLD LOAN INDEXS INFO END *********************** */

/** ***************** GET PARTICULAR GOLD LOAN INDEXS INFO START *********************** */
export const getParticularGoldLoanIndexInfoStart = (getData: any) => ({
	type: GoldLoanActionTypes.GET_PARTICULAR_GOLD_LOAN_INDEX_INFO_START,
	payload: getData,
});

export const getParticularGoldLoanIndexInfoSuccess = (successData: any) => ({
	type: GoldLoanActionTypes.GET_PARTICULAR_GOLD_LOAN_INDEX_INFO_SUCCESS,
	payload: successData,
});

export const getParticularGoldLoanIndexInfoFailure = (failureData: any) => ({
	type: GoldLoanActionTypes.GET_PARTICULAR_GOLD_LOAN_INDEX_INFO_FAILURE,
	payload: failureData,
});

export const getParticularGoldLoanIndexInfoResponseResetStart = () => ({
	type: GoldLoanActionTypes.GET_PARTICULAR_GOLD_LOAN_INDEX_INFO_RESPONSE_RESET,
});

export const getParticularGoldLoanIndexInfoResponseChanged = () => ({
	type: GoldLoanActionTypes.GET_PARTICULAR_GOLD_LOAN_INDEX_INFO_RESPONSE_CHANGED,
});
/** ***************** GET PARTICULAR GOLD LOAN INDEXS INFO END *********************** */

/** ***************** GET GOLD LOAN INDEXS INFO START *********************** */
export const updateGoldLoanIndexCollectionStart = (getData: any) => ({
	type: GoldLoanActionTypes.UPDATE_GOLD_LOAN_INDEX_COLLECTION_START,
	payload: getData,
});

export const updateGoldLoanIndexCollectionSuccess = (successData: any) => ({
	type: GoldLoanActionTypes.UPDATE_GOLD_LOAN_INDEX_COLLECTION_SUCCESS,
	payload: successData,
});

export const updateGoldLoanIndexCollectionFailure = (failureData: any) => ({
	type: GoldLoanActionTypes.UPDATE_GOLD_LOAN_INDEX_COLLECTION_FAILURE,
	payload: failureData,
});

export const updateGoldLoanIndexCollectionResponseResetStart = () => ({
	type: GoldLoanActionTypes.UPDATE_GOLD_LOAN_INDEX_COLLECTION_RESPONSE_RESET,
});

export const updateGoldLoanIndexCollectionResponseChanged = () => ({
	type: GoldLoanActionTypes.UPDATE_GOLD_LOAN_INDEX_COLLECTION_RESPONSE_CHANGED,
});
/** ***************** GET GOLD LOAN INDEXS INFO END *********************** */

/** ***************** GET MEMBER GOLD COLLECTION DETAILS START *********************** */
export const getMemberGoldCollectionDetailsStart = (getData: any) => ({
	type: GoldLoanActionTypes.GET_MEMBER_GOLD_COLLECTION_DETAILS_START,
	payload: getData,
});

export const getMemberGoldCollectionDetailsSuccess = (successData: any) => ({
	type: GoldLoanActionTypes.GET_MEMBER_GOLD_COLLECTION_DETAILS_SUCCESS,
	payload: successData,
});

export const getMemberGoldCollectionDetailsFailure = (failureData: any) => ({
	type: GoldLoanActionTypes.GET_MEMBER_GOLD_COLLECTION_DETAILS_FAILURE,
	payload: failureData,
});

export const getMemberGoldCollectionDetailsResponseResetStart = () => ({
	type: GoldLoanActionTypes.GET_MEMBER_GOLD_COLLECTION_DETAILS_RESPONSE_RESET,
});

export const getMemberGoldCollectionDetailsResponseChanged = () => ({
	type: GoldLoanActionTypes.GET_MEMBER_GOLD_COLLECTION_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET MEMBER GOLD COLLECTION DETAILS END *********************** */
